import axios from "axios";

export const state = {
    contributions: [],
};

export const getters = {
    contributions: state => state.contributions,
};

export const mutations = {
    setContributions(state, newValue) {
        state.contributions = newValue
    },
};

export const actions = {
    async fetchContributions({ commit, rootState }) {
        const fyear = rootState.financialyears.currentFinancialYear;
        await axios.get(`/contributions/${fyear}`).then(res => {
            commit('setContributions', res.data.contributions)
        })
    },
};
